/**
 * Locale dictionary registry.
 *
 * Adding a language is a two-step change:
 *   1. Create `./locales/<code>.ts` typed against `Dictionary` from `./locales/en`.
 *   2. Register it here AND add `<code>` to `SUPPORTED_LOCALES` in `./config`.
 *
 * Dictionaries are imported synchronously so the resolver can return one
 * during the initial render — there's no need for a Suspense boundary or a
 * loading state on locale changes.
 */

import { en, type Dictionary } from "./locales/en";
import { nl } from "./locales/nl";
import type { SupportedLocale } from "./config";

export const DICTIONARIES: Record<SupportedLocale, Dictionary> = {
  en,
  nl,
};

export type { Dictionary };
